/**
 * The competitor stage's form state: the Offer the discovery runs from
 * (prefilled from the approved profile), the Owner's decision reason, the
 * manual-entry fields, and the replacement pair.
 */

import { useEffect, useState } from 'react';

import type { AsyncState } from '../common.js';
import type { AnalysisRunDetail } from './analysis-run-detail.js';

export type CompetitorForms = ReturnType<typeof useCompetitorForms>;

export function useCompetitorForms(state: AsyncState<AnalysisRunDetail>) {
  const [selectedOfferId, setSelectedOfferId] = useState('');
  const [competitorReason, setCompetitorReason] = useState('');
  const [manualName, setManualName] = useState('');
  const [manualUrl, setManualUrl] = useState('');
  const [manualOffer, setManualOffer] = useState('');
  const [manualGeography, setManualGeography] = useState('');
  const [manualDelivery, setManualDelivery] = useState('');
  const [manualAudience, setManualAudience] = useState('');
  const [manualNeed, setManualNeed] = useState('');
  const [manualNote, setManualNote] = useState('');
  const [replacePrior, setReplacePrior] = useState('');
  const [replaceWith, setReplaceWith] = useState('');

  useEffect(() => {
    if (state.status !== 'ready' || selectedOfferId !== '') return;
    const firstOffer = state.value.day2.approvedProfile?.payload.offers[0];
    if (firstOffer !== undefined) setSelectedOfferId(firstOffer.localId);
  }, [selectedOfferId, state]);

  return {
    selectedOfferId,
    setSelectedOfferId,
    competitorReason,
    setCompetitorReason,
    manualName,
    setManualName,
    manualUrl,
    setManualUrl,
    manualOffer,
    setManualOffer,
    manualGeography,
    setManualGeography,
    manualDelivery,
    setManualDelivery,
    manualAudience,
    setManualAudience,
    manualNeed,
    setManualNeed,
    manualNote,
    setManualNote,
    replacePrior,
    setReplacePrior,
    replaceWith,
    setReplaceWith,
  };
}
